import { render, staticRenderFns } from "./LeaderAppointments.vue?vue&type=template&id=09145026&scoped=true&"
import script from "./LeaderAppointments.vue?vue&type=script&lang=js&"
export * from "./LeaderAppointments.vue?vue&type=script&lang=js&"
import style0 from "./LeaderAppointments.vue?vue&type=style&index=0&id=09145026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09145026",
  null
  
)

export default component.exports